






























































import Input from '../../common/Input/Input.vue';
import CheckBox from '../../common/CheckBox/CheckBox.vue';
import Vue, { PropType } from 'vue';
import UniversalCountChart from '../../common/Chart/UniversalCountChart.vue';

export default Vue.extend({
  components: { Input, CheckBox, UniversalCountChart },
  props: {
    value: {
      type: Object as PropType<{
        minValue: undefined | number;
        maxValue: undefined | number;
      }>,
    },
  },
  data(): {
    minValue: undefined | number;
    avgValue: undefined | number;
    maxValue: undefined | number;
    isMinActive: boolean;
    isAvgActive: boolean;
    isMaxActive: boolean;
    isValid: boolean;
  } {
    return {
      minValue: undefined,
      avgValue: undefined,
      maxValue: undefined,
      isMinActive: false,
      isAvgActive: false,
      isMaxActive: false,
      isValid: false,
    };
  },
  methods: {
    onInput() {
      this.isValid =
        // 3가지 입력 폼 모두 비활성화 시
        (this.isMinActive || this.isAvgActive || this.isMaxActive) &&
        // 유효하지 않은 값 입력 시
        !(
          (this.isMinActive && (!this.minValue || isNaN(this.minValue))) ||
          (this.isAvgActive && (!this.avgValue || isNaN(this.avgValue))) ||
          (this.isMaxActive && (!this.maxValue || isNaN(this.maxValue)))
        );

      if (this.isValid) {
        // 정상 입력
        this.$emit('input', {
          minValue:
            this.isMinActive && this.minValue ? +this.minValue : undefined,
          avgValue:
            this.isAvgActive && this.avgValue ? +this.avgValue : undefined,
          maxValue:
            this.isMaxActive && this.maxValue ? +this.maxValue : undefined,
        });
      } else {
        this.$emit('input', undefined);
      }
    },
  },
  watch: {
    isMinActive() {
      this.minValue = undefined;
    },
    isAvgActive() {
      this.avgValue = undefined;
    },
    isMaxActive() {
      this.maxValue = undefined;
    },
  },
});
